"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// |-------------------------------|
// | This is code of a web worker. |
// | This code should remain       |
// | dependency free.              |
// |-------------------------------|
var message_1 = require("./shared/message");
var createArrayGrid_1 = require("./calculateRmZones/createArrayGrid");
var calculateClassification_1 = require("./calculateRmZones/calculateClassification");
var isWorkerContext = typeof document === 'undefined';
if (isWorkerContext) {
    self.onmessage = function (event) {
        console.log('🔨 Worker received message');
        if (!isCalculateMessage(event)) {
            self.postMessage({
                error: 'Invalid zone-classification worker message',
            });
            return;
        }
        var payload = event.data.payload;
        var combinedClassification = {};
        try {
            console.log('🔨 Processing', payload.panelsByGroupId.length, 'panel groups');
            payload.panelsByGroupId.forEach(function (_a) {
                var groupId = _a[0], panels = _a[1];
                console.log("\uD83D\uDD28 Processing group ".concat(groupId, " with ").concat(panels.length, " panels"));
                var grid = (0, createArrayGrid_1.createArrayGrid)(panels, payload.gridSettings);
                var classification = (0, calculateClassification_1.calculateClassification)(grid, payload.classificationSettings);
                console.log("\uD83D\uDD28 Group ".concat(groupId, " classification keys:"), Object.keys(classification).length);
                combinedClassification = Object.assign({}, combinedClassification, classification);
            });
            console.log('🔨 Total classifications:', Object.keys(combinedClassification).length);
            self.postMessage({
                classification: combinedClassification,
            });
        }
        catch (error) {
            console.error('🔨 Worker error:', error);
            self.postMessage({
                error: error instanceof Error ? error.message : String(error),
            });
        }
    };
}
var isCalculateMessage = function (event) {
    var _a;
    var message = event === null || event === void 0 ? void 0 : event.data;
    return ((message === null || message === void 0 ? void 0 : message.type) === message_1.CALCULATE_RM_ZONES &&
        Array.isArray((_a = message.payload) === null || _a === void 0 ? void 0 : _a.panelsByGroupId));
};
